/**
 * Collection/search product cards — Add to cart & Buy now (1 unit per click).
 * Primary handler lives in add-to-cart.js; this file is a fallback only.
 */
(function () {
  if (window.__lbCardAddBound) return;

  var REF_QTY = 1;

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }

  function cartPageUrl() {
    return routesRoot() + "cart?country=US";
  }

  function cartApiUrl(path) {
    var url = routesRoot() + path;
    if (url.indexOf("country=") >= 0) return url;
    return url + (url.indexOf("?") >= 0 ? "&" : "?") + "country=US";
  }

  function parseQty(raw) {
    var n = Number(raw);
    if (!Number.isFinite(n) || n < 1) return REF_QTY;
    n = Math.floor(n);
    var max =
      window.LbQtyLimit && typeof window.LbQtyLimit.max === "function"
        ? window.LbQtyLimit.max()
        : Number(window.LB_MAX_QTY_PER_ITEM) || 24;
    return n > max ? max : n;
  }

  function hideToast() {
    var toast = document.getElementById("lb-cart-toast");
    if (!toast) return;
    toast.classList.remove("is-visible", "is-interactive");
    clearTimeout(toast._timer);
  }

  function showToast(msg, isError) {
    var toast = document.getElementById("lb-cart-toast");
    if (!toast) {
      if (isError) window.alert(msg);
      return;
    }
    toast.textContent = msg;
    toast.className =
      "lb-cart-toast" + (isError ? " lb-cart-toast--error" : "") + " is-visible";
    clearTimeout(toast._timer);
    toast._timer = setTimeout(hideToast, isError ? 4000 : 2600);
  }

  function showAddedPanel(qty) {
    var toast = document.getElementById("lb-cart-toast");
    if (!toast) {
      showToast(addedToastMessage(qty), false);
      return;
    }
    toast.innerHTML =
      '<p class="lb-cart-toast__msg">' +
      addedToastMessage(qty) +
      "</p>" +
      '<div class="lb-cart-toast__actions">' +
      '<button type="button" class="lb-cart-toast__btn" data-toast-dismiss>Continue shopping</button>' +
      '<a href="' +
      cartPageUrl() +
      '" class="lb-cart-toast__btn lb-cart-toast__btn--gold">View cart</a>' +
      "</div>";
    toast.className = "lb-cart-toast is-visible is-interactive";
    clearTimeout(toast._timer);
    toast._timer = setTimeout(hideToast, 8000);
    var dismiss = toast.querySelector("[data-toast-dismiss]");
    if (dismiss) {
      dismiss.addEventListener("click", hideToast, { once: true });
    }
  }

  async function fetchCart() {
    var r = await fetch(cartApiUrl("cart.js"), { credentials: "same-origin" });
    if (!r.ok) return null;
    return r.json();
  }

  async function removeUnavailableItems(cart) {
    if (!cart || !Array.isArray(cart.items) || !cart.items.length) return cart;
    var unavailable = cart.items.filter(function (item) {
      return item && item.available === false;
    });
    if (!unavailable.length) return cart;

    var latest = cart;
    for (var i = 0; i < unavailable.length; i += 1) {
      var item = unavailable[i];
      var rm = await fetch(cartApiUrl("cart/change.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ id: item.key, quantity: 0 }),
      });
      if (!rm.ok) continue;
      latest = await rm.json();
    }
    return latest;
  }

  async function postAdd(variantId, quantity) {
    return fetch(cartApiUrl("cart/add.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: variantId, quantity: quantity }),
    });
  }

  async function postChange(lineKey, quantity) {
    return fetch(cartApiUrl("cart/change.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: lineKey, quantity: quantity }),
    });
  }

  function isFeeCartItem(item) {
    if (!item) return true;
    if (window.LbRemoveFee && typeof window.LbRemoveFee.isFeeItem === "function") {
      return window.LbRemoveFee.isFeeItem(item);
    }
    return String(item.handle || item.product_handle || "").trim() === "lb-order-margin";
  }

  function findCartLineForVariant(cart, variantId) {
    if (!cart || !Array.isArray(cart.items)) return null;
    var vid = String(variantId);
    for (var i = 0; i < cart.items.length; i += 1) {
      var item = cart.items[i];
      if (!item || isFeeCartItem(item)) continue;
      if (String(item.variant_id) === vid) return item;
    }
    return null;
  }

  async function upsertCardLine(variantId, qty) {
    var cart = await fetchCart();
    if (window.LbQtyLimit && typeof window.LbQtyLimit.capLineQty === "function") {
      qty = window.LbQtyLimit.capLineQty(qty, 1);
    }
    var line = cart ? findCartLineForVariant(cart, variantId) : null;
    if (line) {
      if (line.quantity === qty) return cart;
      var changeRes = await postChange(line.key, qty);
      if (!changeRes.ok) throw new Error("Could not update cart.");
      return changeRes.json();
    }
    var addRes = await postAdd(variantId, qty);
    if (!addRes.ok) throw new Error("Could not add this item to cart.");
    return fetchCart();
  }

  function addedToastMessage(qty) {
    return qty === 1 ? "Added to cart" : "Added " + qty + " to cart";
  }

  function headerCartUnits(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    var units = 0;
    cart.items.forEach(function (item) {
      if (!item) return;
      if (window.LbRemoveFee && typeof window.LbRemoveFee.isFeeItem === "function") {
        if (window.LbRemoveFee.isFeeItem(item)) return;
      } else if (String(item.handle || item.product_handle || "").trim() === "lb-order-margin") {
        return;
      }
      units += item.quantity || 0;
    });
    return units;
  }

  function readHeaderCartUnits() {
    var countEl = document.getElementById("lb-header-cart-count");
    if (!countEl) return 0;
    return parseInt(countEl.textContent, 10) || 0;
  }

  function setHeaderCartUnits(units) {
    var countEl = document.getElementById("lb-header-cart-count");
    if (!countEl) return;
    countEl.textContent = String(units);
    var cartLink = countEl.closest(".lb-header-cart");
    if (cartLink) cartLink.setAttribute("aria-label", "Cart, " + units + " items");
  }

  function updateHeaderCartCount(cart) {
    if (
      window.LbUkUsShipping &&
      typeof window.LbUkUsShipping.updateHeaderCartCount === "function"
    ) {
      window.LbUkUsShipping.updateHeaderCartCount(cart);
      return;
    }
    setHeaderCartUnits(headerCartUnits(cart));
  }

  async function refreshCartUi(cart) {
    if (!cart) return;
    updateHeaderCartCount(cart);
    document.dispatchEvent(new CustomEvent("lb:cart-updated", { detail: { cart: cart } }));
    if (window.LbUkUsShipping && typeof window.LbUkUsShipping.refreshCart === "function") {
      window.LbUkUsShipping.refreshCart(cart);
    }
  }

  async function cardAdd(variantId, qty, btn, goCheckout) {
    if (!variantId || btn.disabled) return;
    goCheckout = !!(goCheckout && btn && btn.hasAttribute("data-card-buy"));

    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = "Adding…";

    try {
      var cart = await upsertCardLine(variantId, qty);
      if (cart) {
        await refreshCartUi(cart);
      }

      if (goCheckout) {
        if (cart) cart = await removeUnavailableItems(cart);
        if (window.LbRemoveFee && typeof window.LbRemoveFee.removeFeeLines === "function") {
          cart = await window.LbRemoveFee.removeFeeLines(cart);
        }
        if (!cart || cart.item_count === 0) {
          showToast("Could not start checkout.", true);
          return;
        }
        window.location.assign(routesRoot() + "checkout");
        return;
      }

      btn.textContent = "Added";
      showAddedPanel(qty);
      setTimeout(function () {
        btn.textContent = original;
      }, 1200);
    } catch (e) {
      btn.textContent = original;
      showToast(e instanceof Error ? e.message : "Could not add item", true);
    } finally {
      if (!goCheckout) btn.disabled = false;
    }
  }

  document.addEventListener(
    "click",
    function (event) {
      var addBtn =
        event.target && event.target.closest
          ? event.target.closest("[data-card-add]")
          : null;
      var buyBtn =
        event.target && event.target.closest
          ? event.target.closest("[data-card-buy]")
          : null;
      var btn = addBtn || buyBtn;
      if (!btn) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      var card = btn.closest("[data-product-card]");
      var qtyInput = card ? card.querySelector("[data-card-qty]") : null;
      var variantId = btn.getAttribute("data-variant-id");
      var qty = qtyInput
        ? parseQty(qtyInput.value)
        : parseQty(btn.getAttribute("data-qty") || String(REF_QTY));
      cardAdd(variantId, qty, btn, !addBtn && !!buyBtn);
    },
    true
  );
})();
